import { observable } from "mobx";
import TimesheetService from "../../../services/TimesheetService";

//RHFPP-1447-automatizacao-timesheets

export default class TabelaAdministracaoStore {
    @observable tableRef;
    @observable observacoes;
    @observable motivoErro;
    @observable timesheetId;
    @observable acaoSelecionada;

    constructor(loginStore) {
        this.loginStore = loginStore;
        this.tableRef = null;
        this.observacoes = "";
        this.motivoErro = "";
        this.timesheetId=null;
        this.acaoSelecionada=null;

        this.timesheetService = new TimesheetService();
    }

    setTableRef(ref) {
        this.tableRef = ref;
    }

    cleanSucessList(){
        console.log("Limpou ------>");
        this.observacoes = "";
        this.tableRef.state.selectedRowKeys = [];
    }

    cleanErrorList(){
        console.log("Limpou 2 ------>");
        this.observacoes = "";
    }

    tratarErroTimesheet(timesheet){
        if (this.acaoSelecionada != null && this.acaoSelecionada == 1)
            return this.timesheetService.cancelarTimesheet(timesheet, this.observacoes);
        else if(this.acaoSelecionada != null && this.acaoSelecionada == 0)
            return this.timesheetService.liberarReprocessamento(timesheet.timesheetId);

    }

    setObservacoes(value) {
        this.observacoes = value;
    }

    setAcaoSelecionada(value) {
        this.acaoSelecionada = value == '' ? null : value;
    }


}